import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {catchError, map} from "rxjs/operators";

import {GREETING, SYSTEM_GREETING_API_URL} from "../../defines/protocol";
import {ApiService} from "../api/api.service";

export const LOCALSTORAGE_KEY_GREETING = 'greeting';

export const DEFAULT_GREETING_TITLE = "와따메, 겁나게 반갑소잉!";
export const DEFAULT_GREETING_MESSAGE = "오매, 니를 봉께 내 가심이 요로고 뛰어 부러야!";

@Injectable({
  providedIn: 'root'
})
export class GreetingService {

  private greetingTitle?: string;
  private greetingmessage?: string;
  private index = 0;
  private total = 0;

  constructor(
    private api: ApiService,
  ) {
    this.load();
  }


  public GetGreeting(): Observable<GREETING> {
    console.log('GetGreeting::GetGreeting()');

    const url = SYSTEM_GREETING_API_URL + this.index + '/';
    return this.api.Get(url).pipe(
      map((data: any) => {
        console.log('GetGreeting::GetGreeting()', data);
        if ('total' in data) {
          this.total = data.total;
          this.index = this.index + 1;

          // console.warn('GetGreeting::GetGreeting()', this.index, this.total);
          if (this.index >= this.total) {
            this.index = 0;
          }
          this.save();

          return {title: data.title, message: data.message};
        } else {
          return {title: this.greetingTitle, message: this.greetingmessage};
        }
      }),
      catchError((err) => {
        console.error('GetGreeting::GetGreeting()', err);
        if ('total' in err.error) {
          this.total = err.error.total;

          // console.warn('GetGreeting::GetGreeting()', this.index, this.total);
          if (this.index >= this.total) {
            this.index = 0;
          }
        }
        else {
          this.total = 0;
          this.index = 0;
        }
        this.save();
        return of({title: DEFAULT_GREETING_TITLE, message: DEFAULT_GREETING_MESSAGE});
      }),
    );
  }

  toJSON(): any {
    return {
      total: this.total,
      index: this.index,
      title: this.greetingTitle,
      message: this.greetingmessage,
    };
  }

  public load(): void {
    const txtGreeting = localStorage.getItem(LOCALSTORAGE_KEY_GREETING);
    const greeting = txtGreeting ? JSON.parse(txtGreeting) : null;

    this.total = (greeting && greeting.total) ?? 0;
    this.index = (greeting && greeting.index) ?? 0;
    this.greetingTitle = greeting?.title ?? '';
    this.greetingmessage = greeting?.message ?? '';

    console.log('GreetingService::load()', this);
  }

  public save(): void {
    localStorage.setItem(LOCALSTORAGE_KEY_GREETING, JSON.stringify(this));
  }
}
